<template>
  <nav
    class="navbar navbar-default"
    :class="{templates: section === 'templates'}"
  >
    <div class="navbar-inner">
      <div class="navbar-inner">
        <ul
          class="nav navbar-nav vld-parent"
          :class="{templates: section === 'templates'}"
        >
          <li :class="{active: section === 'templates'}">
            <a @click="openTemplateSection()">Templates</a>
          </li>
          <li
            :class="{
              active: section === 'dynamic',
              forbidden: !dynamicContents
            }"
            style="margin-right: 5px !important"
          >
            <a v-if="dynamicContents" @click="openDynamic()">{{
              $t('content.dynamic_contents')
            }}</a>
            <a v-else disabled="disabled"
              >{{ $t('content.dynamic_contents') }}
            </a>
          </li>
          <span
            v-if="showBanner"
            id="dynamic-content-banner"
            class="alert alert-warning"
            role="alert"
          >
            <div class="glyphicon glyphicon-exclamation-sign"></div>
            <strong> NEW:</strong>
            {{ $t('content.dynamic_contents_alert') }}
            <a
              href="https://new.mailup.com/it/template-titolonome-nuova-features-piattaforma-46Vbg2dp"
              target="_blank"
              class="alert-link"
              >{{ $t('general.here') }}</a
            >
          </span>
        </ul>
      </div>
      <close-button />
    </div>
  </nav>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import CloseButton from './CloseButton.vue';

const NEWS_BANNER_VISIBLE_UNTIL = new Date('2024-01-01');

export default {
  name: 'TopToolbar',
  components: {
    CloseButton
  },
  computed: {
    ...mapState({
      section: state => state.section,
      dynamicContents: state => state.dynamicContents,
      showBanner: function () {
        const today = new Date();
        return today < NEWS_BANNER_VISIBLE_UNTIL;
      }
    })
  },
  methods: {
    ...mapMutations([
      'openTemplateSection',
      'openDynamicSection',
      'closeEditor'
    ]),
    ...mapActions(['loadCustomerInfo']),
    openDynamic: function () {
      if (!this.dynamicContents) return;
      this.closeEditor();
      this.openDynamicSection();
    }
  },
  mounted: function () {
    this.loadCustomerInfo();
  }
};
</script>

<style scoped>
nav.templates {
  margin-bottom: 0;
  border-bottom: 0;
}
.navbar.templates {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-color: #f8f8f8;
}
li {
  cursor: pointer;
}

li.active > a {
  background-color: #81c784 !important;
  color: white !important;
}

.forbidden {
  cursor: not-allowed;
}

#dynamic-content-banner {
  top: 15px;
  position: relative;
  padding: 10px;
}
</style>
